"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const CollectibleERC721SharedContract_json_1 = tslib_1.__importDefault(require("../abis/CollectibleERC721SharedContract.json"));
const ContractVersion_1 = require("./ContractVersion");
class CollectibleContractVersion extends ContractVersion_1.ContractVersion {
    constructor() {
        super(...arguments);
        this.version = "v1.2";
        this.deployedContractsByVersion = {
            v1: {
                goerliAddress: "0x6A81c04269274c173999FE52Aa99e0cd66E9eEFd",
                mainnetAddress: "0x60b6c13d62be7cb135dd626273f4cc09f4c95bba",
                abi: CollectibleERC721SharedContract_json_1.default,
            },
            "v1.1": {
                goerliAddress: "0xe4a96b242CdA89fefb0baf407ff1BBBBdC3E2f67",
                mainnetAddress: "0x60b6c13d62be7cb135dd626273f4cc09f4c95bba",
                abi: CollectibleERC721SharedContract_json_1.default,
            },
            "v1.2": {
                goerliAddress: "0x546B820779ceC2337380cE15E2Ff62BDb96ABa4E",
                mainnetAddress: "0xDb707aF289d5a63Bd72E6761f0E91B414485D42A",
                abi: CollectibleERC721SharedContract_json_1.default,
            },
        };
    }
}
exports.default = new CollectibleContractVersion();
//# sourceMappingURL=CollectibleContractVersion.js.map